import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './menu.scss';

const componentMainClass = 'menu';

const Menu = ({ className, children, type, ...other }) => {
    const getStyles = classNames.bind(styles);
    const componentClasses = getStyles(componentMainClass, `${componentMainClass}--${type}`, className);
    const MenuProps = {
        className: componentClasses,
        ...other
    };

    return <nav {...MenuProps}>{children}</nav>;
};

Menu.propTypes = {
    /** The class of the menu component. */
    className: PropTypes.string,
    /** Type of menu component: vertical or horizontal */
    type: PropTypes.oneOf(['vertical', 'horizontal'])
};

Menu.defaultProps = {
    className: '',
    type: 'vertical'
};

export default Menu;
